// Fechas pasadas en el paso «Configuración» de una campaña (hallazgo de QA, 16-oct-2026): el wizard
// dejaba elegir y guardar una campaña con inicio/fin ya vencidos, y el rechazo llegaba hasta la
// aprobación. Aquí viven las dos piezas puras: «qué día es hoy» en la zona horaria de la campaña y
// «¿esta fecha es una fecha pasada no permitida?».

/** `YYYY-MM-DD` de hoy en `timeZone` (la de la campaña). Una zona inválida cae a la del navegador. */
export function todayInTimeZone(timeZone: string, now: Date = new Date()): string {
  const fmt = (tz?: string) => new Intl.DateTimeFormat('en-CA', {
    timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now);
  try {
    return fmt(timeZone || undefined);
  } catch {
    return fmt();
  }
}

/**
 * Atributo `min` del `<input type="date">`. Es `hoy`, salvo que la fecha YA guardada sea anterior: una
 * campaña iniciada conserva su inicio pasado y no debe verse como inválida solo por abrirla.
 */
export function minFechaCampana(hoy: string, original: string): string {
  return original && original < hoy ? original : hoy;
}

/**
 * ¿`valor` es una fecha pasada que no se permite? Solo si es anterior a hoy Y distinta de la que ya
 * traía la campaña: lo que no se toca no se bloquea (editar una campaña ya iniciada), lo que se
 * cambia no puede retroceder a un día que ya pasó. Vacío no cuenta (lo exige otra regla).
 */
export function esFechaPasadaNoPermitida(valor: string, hoy: string, original: string): boolean {
  return Boolean(valor) && valor < hoy && valor !== original;
}
